/* Branch RUM (prototype): page speed, errors, Visually allocations and tab crashes, sent to our
 * collector (tools/rum-collector) as beacons. Configured by snippets/branch-rum.liquid.
 *
 * Crash detection: iOS kills a tab's page process without any event, and Safari then reloads the
 * same URL (navigation type back_forward on iOS Safari 26). Every second this page writes a small heartbeat to localStorage and marks a clean exit
 * on pagehide; the next load of the same path in the same tab that finds a visible, recent
 * heartbeat without an exit reports a page_crash with the dead page's last state and steps.
 * A heartbeat without an exit followed by a different path is a page left before its load event
 * (browsers fire no pagehide then); it is recorded on the page_view, not as a crash.
 * When Safari closes the dead tab instead of reloading it (or the shopper starts a new tab), the
 * next page opens in another tab. If the last page anywhere was on screen with no exit and its
 * heartbeat has stopped moving, that is reported too, with confidence low.
 *
 * Events: page_view (3 s after load), page_summary (when the page is hidden or left, with request
 * summaries), page_crash (on the load after an unclean end), page_waterfall (sampled: every
 * request with its timing, 10 s after load, in chunks).
 */
(function () {
  'use strict';
  var cfg = window.BranchRUMConfig || {};
  if (!cfg.endpoint || window.BranchRUM) return;
  var theme = (window.Shopify && window.Shopify.theme) || {};
  var onMain = theme.role === 'main';
  if (cfg.onlyNonMain !== false && onMain) return;
  // On the published theme only shoppers count: automated browsers (our own test runners set
  // navigator.webdriver) and crawlers or lab tools such as Lighthouse and PageSpeed are left out.
  // Development and preview themes keep reporting them, which is how changes are tested there.
  if (onMain && (navigator.webdriver || /bot\/|crawl|spider|slurp|facebookexternalhit|lighthouse|pagespeed|headlesschrome|gtmetrix|pingdom|uptimerobot/i.test(navigator.userAgent || ''))) return;
  // The published theme has its own sample rates (mainSample, mainWaterfallSample) when set.
  var sampleRate = onMain && cfg.mainSample != null ? cfg.mainSample : cfg.sample;
  var waterfallRate = onMain && cfg.mainWaterfallSample != null ? cfg.mainWaterfallSample : cfg.waterfallSample;

  /* ---------- storage and ids ---------- */
  function get(store, k) { try { var v = store.getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; } }
  function set(store, k, v) { try { store.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function rnd() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 10); }
  var LS = window.localStorage, SS = window.sessionStorage;
  var now = Date.now();

  var session = get(LS, 'brum:session');
  if (!session || now - session.last > 30 * 60 * 1000) session = { id: rnd(), sampled: Math.random() < (sampleRate == null ? 1 : sampleRate) };
  session.last = now; set(LS, 'brum:session', session);
  if (!session.sampled) return;

  var tabId = get(SS, 'brum:tab'); if (!tabId) { tabId = rnd(); set(SS, 'brum:tab', tabId); }
  var tabPageIndex = (get(SS, 'brum:n') || 0) + 1; set(SS, 'brum:n', tabPageIndex);
  var productPages = get(SS, 'brum:pp') || 0;
  if (cfg.template === 'product') { productPages += 1; set(SS, 'brum:pp', productPages); }
  // Pages this tab has put in the back/forward cache so far (they stay in the same page process).
  // An upper bound: the browser drops cached pages under memory pressure without telling the page.
  var cachedBefore = get(SS, 'brum:cached') || 0;
  var pageId = rnd();
  var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
  var navType = nav.type || 'unknown';

  /* ---------- page facts ---------- */
  function visuallyIds() {
    var c = window.loomi_ctx || {}, s = c.session || get(LS, 'vsly_session') || {};
    return { uid: c.userId || null, sid: s.id || null };
  }
  function experiments() {
    var list = window.loomi && window.loomi.conf && window.loomi.conf.experiments;
    if (!list || !list.map) return null;
    // Visually lists its audiences (personalization segments) here too, flagged isAudience, with the
    // placeholder name "A"; their real names exist only in Visually's admin.
    return list.map(function (x) { var e = { id: x.name, variant: x.variant, name: x.gaName, variant_name: x.gaVariant }; if (x.isAudience) e.audience = true; return e; });
  }
  function themeTests() {
    var out = {}, spans = document.querySelectorAll('[id$="-test"][data-test-active]');
    for (var i = 0; i < spans.length; i++) out[spans[i].id] = { active: spans[i].getAttribute('data-test-active') === 'true', variant: spans[i].getAttribute('data-test-variant') };
    return out;
  }
  // Deploy marker from the snippet: a fingerprint of the theme's asset versions (the same on every
  // page of a deploy), an optional explicit build id, and the theme folder in asset URLs.
  var buildInfo = { id: cfg.build || null, fp: cfg.buildFp || null, theme_path: ((cfg.assetBase || '').match(/\/t\/(\d+)\//) || [])[1] || null };
  function build() { return buildInfo; }
  // Visitor country and state from their IP, once per session: Shopify's Customer Privacy API
  // (getRegion() is country + state code, e.g. "USCA"), else Shopify's browsing context
  // suggestions (country only). Plus the market being browsed (Shopify.country).
  var geo = get(LS, 'brum:geo');
  if (!geo || geo.session !== session.id) geo = null;
  function readRegion() {
    var p = window.Shopify && window.Shopify.customerPrivacy;
    if (!p || typeof p.getRegion !== 'function') return null;
    try { var r = String(p.getRegion() || ''); if (/^[A-Za-z]{2}/.test(r)) return { country: r.slice(0, 2).toUpperCase(), state: r.length > 2 ? r.slice(2).toUpperCase() : null, source: 'customer_privacy' }; } catch (e) {}
    return null;
  }
  function fetchGeo(fallback) {
    if (geo) return;
    var region = readRegion();
    if (region) { geo = Object.assign({ session: session.id }, region); set(LS, 'brum:geo', geo); return; }
    if (!fallback) return;
    try {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (d) {
        var c = d && d.detected_values && d.detected_values.country;
        geo = { session: session.id, country: (c && (c.handle || c.code)) || null, state: null, source: 'browsing_context' }; set(LS, 'brum:geo', geo);
      }).catch(function () {});
    } catch (e) {}
  }
  function state() {
    var root = document.querySelector('[data-product-3d]'), eng = null;
    try { var c = root && window.BranchConfigurator && window.BranchConfigurator.get(root); eng = c && c.engine; } catch (e) {}
    return {
      dom: document.getElementsByTagName('*').length,
      images: document.images.length,
      iframes: document.getElementsByTagName('iframe').length,
      open3d: !!root && root.getAttribute('data-open') === 'true',
      models: eng && eng.loaded ? eng.loaded.size : null,
      quickview: !!document.querySelector('.tingle-modal--visible'),
      menu: !!document.querySelector('.menu-mobile-improved[data-ajax-initialized="true"]'),
      scrollY: Math.round(window.scrollY)
    };
  }
  function base(event) {
    var v = visuallyIds();
    return {
      event: event, event_id: rnd(), ts: Date.now(),
      session_id: session.id, tab_id: tabId, page_id: pageId,
      tab_page_index: tabPageIndex, product_pages_in_tab: productPages, cached_pages_before: cachedBefore, nav_type: navType,
      host: location.host, path: location.pathname, template: cfg.template || null, product_handle: cfg.product || null, customer: cfg.customer || null,
      theme_id: theme.id ? String(theme.id) : null, theme_role: theme.role || null,
      visually_uid: v.uid, visually_sid: v.sid,
      country: geo ? geo.country : null, state: geo ? geo.state : null, market: (window.Shopify && window.Shopify.country) || null,
      build_id: build().id, build_fp: build().fp, build_theme_path: build().theme_path,
      screen: screen.width + 'x' + screen.height + '@' + (window.devicePixelRatio || 1),
      viewport: window.innerWidth + 'x' + window.innerHeight
    };
  }

  /* ---------- sending ---------- */
  function consentAllows() {
    var p = window.Shopify && window.Shopify.customerPrivacy;
    if (p && typeof p.analyticsProcessingAllowed === 'function') { try { return p.analyticsProcessingAllowed() !== false; } catch (e) {} }
    return true;
  }
  function send(events) {
    if (!consentAllows()) return;
    var body = JSON.stringify({ v: 1, events: events });
    try { if (navigator.sendBeacon && navigator.sendBeacon(cfg.endpoint, new Blob([body], { type: 'text/plain' }))) return; } catch (e) {}
    try { fetch(cfg.endpoint, { method: 'POST', body: body, keepalive: true, mode: 'no-cors', headers: { 'Content-Type': 'text/plain' } }); } catch (e) {}
  }

  /* ---------- crash detection ---------- */
  var HB = 'brum:hb:' + tabId, LAST = 'brum:last';
  var prev = get(LS, HB), lastAny = get(LS, LAST), crash = null, leftEarly = null;
  function unclean(h) { return h && !h.exit && h.visible && now - h.beat < 60 * 1000 && h.page_id !== pageId; }
  if (unclean(prev)) {
    // Safari 26 on iOS marks its automatic reload after a crash as back_forward (seen on a real
    // iPhone, October 1); a plain reload also counts.
    if (prev.path === location.pathname) crash = { confidence: navType === 'reload' || navType === 'back_forward' ? 'high' : 'medium', prev: prev };
    else leftEarly = { path: prev.path, loaded: !!prev.loaded, ms: prev.beat - prev.started };
  } else if (!prev && unclean(lastAny) && lastAny.path === location.pathname && (navType === 'reload' || navType === 'back_forward')) {
    crash = { confidence: 'low', note: 'tab id lost', prev: lastAny };
    if (lastAny.tab_id) { try { LS.removeItem('brum:hb:' + lastAny.tab_id); } catch (e) {} }
  }
  else if (!prev) {
    // A new tab: look for another tab's page that was on screen with no clean exit (switching tabs
    // or apps hides a page first). Either it died and Safari closed its tab, which gives no reload
    // to catch, or it is still open in another window. A live page moves its heartbeat every
    // second, so look again before counting it. Each tab keeps its own key: brum:last alone is not
    // enough, because another tab's late exit write can land on it after the crash. Heartbeats
    // older than a day are cleared on the way.
    var orphans = [];
    try {
      for (var k = LS.length - 1; k >= 0; k--) {
        var key = LS.key(k);
        if (!key || key.indexOf('brum:hb:') !== 0 || key === HB) continue;
        var h = get(LS, key);
        if (!h || now - h.beat > 24 * 3600 * 1000) { LS.removeItem(key); continue; }
        if (!h.exit && h.visible && now - h.beat < 10 * 60 * 1000) orphans.push({ key: key, beat: h.beat, page_id: h.page_id });
      }
    } catch (e) {}
    if (orphans.length) setTimeout(function () {
      orphans.forEach(function (o) {
        var again = get(LS, o.key);
        if (!again || again.beat !== o.beat || again.exit || again.page_id !== o.page_id) return;
        var oe = base('page_crash');
        oe.crash = { confidence: 'low', note: 'tab closed after the page died', prev: again, gap_ms: Date.now() - again.beat };
        oe.experiments = again.experiments || null;
        oe.visually_uid = oe.visually_uid || visuallyIds().uid;
        send([oe]);
        try { LS.removeItem(o.key); } catch (e) {}
      });
    }, 3000);
  }
  if (crash) {
    // The killed page process took its cached pages with it.
    cachedBefore = 0; set(SS, 'brum:cached', 0);
    crash.gap_ms = now - crash.prev.beat;
    var ce = base('page_crash');
    ce.crash = crash;
    ce.experiments = crash.prev.experiments || null;
    setTimeout(function () { ce.visually_uid = ce.visually_uid || visuallyIds().uid; send([ce]); }, 2000);
  }

  /* ---------- heartbeat and breadcrumbs ---------- */
  var hb = { page_id: pageId, tab_id: tabId, path: location.pathname, tab_page_index: tabPageIndex, product_pages_in_tab: productPages, cached_pages_before: cachedBefore, started: now, beat: now, visible: document.visibilityState === 'visible', loaded: document.readyState === 'complete', exit: null, steps: [], state: null, experiments: null };
  var frozen = false, beats = 0, last3d = null, lastQv = null;
  function step(name) { hb.steps.push({ t: Math.round(performance.now()), n: String(name).slice(0, 60) }); if (hb.steps.length > 12) hb.steps.shift(); }
  function write() { if (!frozen) { set(LS, HB, hb); set(LS, LAST, hb); } }
  function beat() {
    hb.beat = Date.now(); hb.visible = document.visibilityState === 'visible';
    if (beats++ % 5 === 0) {
      try {
        hb.state = state();
        if (hb.state.open3d !== last3d) { if (last3d !== null || hb.state.open3d) step(hb.state.open3d ? '3d open' : '3d closed'); last3d = hb.state.open3d; }
        if (hb.state.quickview !== lastQv) { if (hb.state.quickview) step('quick view open'); lastQv = hb.state.quickview; }
        if (!hb.experiments) hb.experiments = experiments();
      } catch (e) {}
    }
    write();
  }
  write();
  var timer = setInterval(beat, 1000);
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-product-3d-pin], [data-product-3d-close], [data-product-3d-expand], .menu-mobile-improved__nav-link, .quick-view-link, [data-addon-handle], button, a');
    if (!t) return;
    var label = (t.getAttribute('data-slot') || t.getAttribute('data-addon-handle') || t.innerText || t.className || t.tagName || '').toString().trim().replace(/\s+/g, ' ').slice(0, 40);
    step('click ' + label); write();
  }, true);
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.type === 'radio' && t.closest && t.closest('.main-product__item')) { step('option ' + (t.name || '') + '=' + (t.value || '').slice(0, 30)); write(); }
  }, true);

  /* ---------- page speed and errors ---------- */
  var m = {}, errs = { count: 0, first: [] };
  function observe(type, fn, opts) { try { var po = new PerformanceObserver(function (l) { l.getEntries().forEach(fn); }); po.observe(Object.assign({ type: type, buffered: true }, opts || {})); } catch (e) {} }
  var lcpEntry = null;
  observe('largest-contentful-paint', function (e) { lcpEntry = e; m.lcp = Math.round(e.startTime); m.lcp_el = (e.element && (e.element.tagName + (e.element.className ? '.' + String(e.element.className).split(' ')[0] : ''))) || null; });
  // LCP in four parts (as web-vitals attribution): time to first byte, then the delay before the
  // LCP resource was requested, its load time, and the delay until it was rendered.
  function lcpBreakdown() {
    if (!lcpEntry) return null;
    var n = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {}, ttfb = n.responseStart || 0, res = null;
    if (lcpEntry.url) { var list = performance.getEntriesByName(lcpEntry.url); for (var i = 0; i < list.length; i++) if (list[i].entryType === 'resource') { res = list[i]; break; } }
    var reqStart = res ? Math.max(ttfb, res.requestStart || res.startTime) : ttfb;
    var respEnd = res ? Math.max(reqStart, res.responseEnd || 0) : ttfb;
    return {
      ttfb: Math.round(ttfb), load_delay: Math.round(reqStart - ttfb), load_time: Math.round(respEnd - reqStart),
      render_delay: Math.round(Math.max(0, lcpEntry.startTime - respEnd)),
      resource: lcpEntry.url ? String(lcpEntry.url).split('?')[0].slice(-120) : null, resource_timing: !!res, size: lcpEntry.size || null
    };
  }
  observe('paint', function (e) { if (e.name === 'first-contentful-paint') m.fcp = Math.round(e.startTime); });
  observe('layout-shift', function (e) { if (!e.hadRecentInput) m.cls = Math.round(((m.cls || 0) + e.value) * 1000) / 1000; });
  observe('event', function (e) { if (e.interactionId && (!m.inp || e.duration > m.inp)) { m.inp = Math.round(e.duration); m.inp_type = e.name; } }, { durationThreshold: 40 });
  observe('longtask', function (e) { m.long_tasks = (m.long_tasks || 0) + 1; m.long_task_ms = (m.long_task_ms || 0) + Math.round(e.duration); });
  function onError(msg, src, line) { errs.count++; if (errs.first.length < 5) errs.first.push({ m: String(msg).slice(0, 160), s: String(src || '').split('?')[0].slice(-80), l: line || null }); }
  window.addEventListener('error', function (e) { onError(e.message || (e.target && e.target.tagName + ' failed to load'), e.filename || (e.target && (e.target.src || e.target.href)), e.lineno); }, true);
  window.addEventListener('unhandledrejection', function (e) { onError('unhandledrejection: ' + (e.reason && (e.reason.message || e.reason)), '', null); });
  function timings() {
    var n = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
    return { ttfb: n.responseStart ? Math.round(n.responseStart) : null, dcl: n.domContentLoadedEventEnd ? Math.round(n.domContentLoadedEventEnd) : null, load: n.loadEventEnd ? Math.round(n.loadEventEnd) : null, transfer_kb: n.transferSize ? Math.round(n.transferSize / 1024) : null };
  }

  /* ---------- requests ---------- */
  function hostOf(u) { try { return new URL(u, location.href).hostname; } catch (e) { return '?'; } }
  function kbOf(r) { return Math.round((r.transferSize || r.encodedBodySize || 0) / 1024); }
  function resources() { try { return performance.getEntriesByType('resource'); } catch (e) { return []; } }
  // Who requested what, overall and before LCP: counts and KB by type and domain, slowest requests.
  function requestSummary() {
    var all = resources(), lcpAt = m.lcp || null;
    function summarize(list) {
      var byType = {}, byHost = {}, kb = 0, third = 0;
      list.forEach(function (r) {
        var h = hostOf(r.name), k = kbOf(r), t = r.initiatorType || 'other';
        byType[t] = (byType[t] || 0) + 1; kb += k;
        if (h !== location.hostname) third++;
        var bh = byHost[h] || (byHost[h] = { d: h, n: 0, kb: 0, ms: 0 }); bh.n++; bh.kb += k; bh.ms += Math.round(r.duration);
      });
      var hosts = Object.keys(byHost).map(function (k) { return byHost[k]; }).sort(function (a, b) { return b.n - a.n; });
      return { n: list.length, kb: kb, other_domains_n: third, by_type: byType, top_domains: hosts.slice(0, 8) };
    }
    var out = { page: summarize(all) };
    if (lcpAt) {
      var before = all.filter(function (r) { return r.startTime < lcpAt; });
      out.before_lcp = summarize(before);
      out.before_lcp.slowest = before.slice().sort(function (a, b) { return b.duration - a.duration; }).slice(0, 5).map(function (r) {
        return { u: hostOf(r.name) + String(r.name).replace(/^https?:\/\/[^/]+/, '').split('?')[0].slice(0, 90), type: r.initiatorType, start: Math.round(r.startTime), dur: Math.round(r.duration), kb: kbOf(r) };
      });
    }
    return out;
  }
  // Sampled full waterfall, compact: hosts listed once; each row is
  // [host index, path, type, start ms, duration ms, KB, response start ms or -1].
  var waterfallSent = false, sampledWaterfall = Math.random() < (waterfallRate == null ? 0.05 : waterfallRate);
  function sendWaterfall() {
    if (waterfallSent || !sampledWaterfall || document.visibilityState !== 'visible' || !consentAllows()) return;
    waterfallSent = true;
    var hosts = [], hostIdx = {}, rows = resources().map(function (r) {
      var h = hostOf(r.name); if (hostIdx[h] === undefined) { hostIdx[h] = hosts.length; hosts.push(h); }
      return [hostIdx[h], String(r.name).replace(/^https?:\/\/[^/]+/, '').split('?')[0].slice(0, 70), r.initiatorType || 'other', Math.round(r.startTime), Math.round(r.duration), kbOf(r), r.responseStart ? Math.round(r.responseStart) : -1];
    });
    var nav = timings(), chunks = [], size = 0, cur = [];
    rows.forEach(function (row) { var n = JSON.stringify(row).length; if (size + n > 30000 && cur.length) { chunks.push(cur); cur = []; size = 0; } cur.push(row); size += n; });
    if (cur.length) chunks.push(cur);
    chunks.forEach(function (c, i) {
      var e = base('page_waterfall');
      e.data = { chunk: i + 1, of: chunks.length, total: rows.length, hosts: hosts, rows: c, lcp: m.lcp || null, lcp_resource: lcpEntry && lcpEntry.url ? String(lcpEntry.url).replace(/^https?:\/\/[^/]+/, '').split('?')[0].slice(0, 70) : null, nav: nav };
      try { fetch(cfg.endpoint, { method: 'POST', body: JSON.stringify({ v: 1, events: [e] }), mode: 'no-cors', headers: { 'Content-Type': 'text/plain' } }); } catch (err) {}
    });
  }

  /* ---------- events ---------- */
  var viewSent = false, summaries = 0, summarySinceVisible = false;
  window.addEventListener('load', function () { hb.loaded = true; write(); });
  function sendView() {
    if (viewSent) return; viewSent = true;
    var e = base('page_view');
    e.metrics = Object.assign(timings(), { lcp: m.lcp || null, fcp: m.fcp || null, lcp_breakdown: lcpBreakdown() }, { state: state() });
    e.experiments = experiments(); e.theme_tests = themeTests();
    if (leftEarly) e.data = { previous_left_before_load: leftEarly };
    send([e]);
  }
  // One summary each time the page is hidden or left (visibilitychange and pagehide both fire).
  function sendSummary(reason) {
    if (summarySinceVisible || summaries >= 5) return; summarySinceVisible = true; summaries++;
    var e = base('page_summary');
    e.metrics = Object.assign(timings(), m, { lcp_breakdown: lcpBreakdown(), requests: requestSummary(), state: hb.state || state(), visible_ms: Math.round(performance.now()) });
    e.errors = errs.count ? errs : null;
    e.experiments = experiments(); e.theme_tests = themeTests();
    e.data = { reason: reason, steps: hb.steps.slice(-12), summary_n: summaries };
    send([e]);
  }
  // The privacy API appears a few seconds into the page; fall back to the request only if it never does.
  function geoSoon() { setTimeout(function () { fetchGeo(false); }, 1000); setTimeout(function () { fetchGeo(true); }, 6000); }
  if (document.readyState === 'complete') { setTimeout(sendView, 3000); geoSoon(); setTimeout(sendWaterfall, 10000); }
  else window.addEventListener('load', function () { setTimeout(sendView, 3000); geoSoon(); setTimeout(sendWaterfall, 10000); });
  setTimeout(sendView, 20000); // pages whose load event never comes still get counted
  document.addEventListener('visibilitychange', function () {
    if (frozen) return;
    hb.visible = document.visibilityState === 'visible'; write();
    if (hb.visible) summarySinceVisible = false;
    else { sendView(); sendSummary('hidden'); }
  });
  window.addEventListener('pagehide', function (e) {
    if (frozen) return;
    hb.exit = e.persisted ? 'bfcache' : 'unload'; hb.visible = false; write();
    if (e.persisted) set(SS, 'brum:cached', (get(SS, 'brum:cached') || 0) + 1);
    sendView(); sendSummary(e.persisted ? 'bfcache' : 'unload');
  });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    hb.exit = null; hb.visible = true; summarySinceVisible = false; step('restored from back/forward cache'); write();
    set(SS, 'brum:cached', Math.max(0, (get(SS, 'brum:cached') || 0) - 1));
  });

  window.BranchRUM = {
    pageId: pageId, tabId: tabId, crash: crash,
    step: function (name) { step(name); write(); },
    // Test hook on non-published themes: stop marking a clean exit, so the next load looks like
    // the load after a crash.
    simulateCrash: theme.role !== 'main' ? function () { frozen = true; clearInterval(timer); hb.beat = Date.now(); hb.visible = true; set(LS, HB, hb); set(LS, LAST, hb); } : undefined
  };
})();
